"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OldArtOfWarAbilityHandler = exports.OldArtOfWarActorAbilityFactory = exports.OldArtOfWarAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const IdArray_1 = require("../../core/utils/IdArray");
const core_2 = require("../../core/effects/core");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class OldArtOfWarAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.OldArtOfWar;
        this.__typeName = "OldArtOfWar";
    }
}
exports.OldArtOfWarAbilityArgs = OldArtOfWarAbilityArgs;
let OldArtOfWarActorAbilityFactory = class OldArtOfWarActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("OldArtOfWar", "AllEnemies", 4);
    }
};
OldArtOfWarActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("OldArtOfWar")
], OldArtOfWarActorAbilityFactory);
exports.OldArtOfWarActorAbilityFactory = OldArtOfWarActorAbilityFactory;
let OldArtOfWarAbilityHandler = class OldArtOfWarAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const randomEnemyOrder = (0, IdArray_1.shuffle)(container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies));
        container.applyJumpingProjectileAttackWithDamage({
            sequence,
            attackerId: ability.invokerId,
            targetIds: randomEnemyOrder,
            attackType: "magic",
            abilityKey: ability.args.__typeName,
            projectileType: "MonkHat",
            projectilePath: "line",
            toApply: [
                AbilityDamage_1.AbilityDamage.Focus("Death", 90)
            ],
            onHit: (sequence, _attack, _damages, targetId) => {
                sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(targetId, "chest"), "PurpleAndWhiteCircleish"));
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId,
                    duration: Duration_1.Duration.Turns(3),
                    effect: new core_2.LinkedEffectsEffectArgs([
                        new core_2.SlowEffectArgs(5),
                        new core_2.VulnerabilityEffectArgs(3)
                    ], true)
                });
            },
        });
    }
};
OldArtOfWarAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.OldArtOfWar)
], OldArtOfWarAbilityHandler);
exports.OldArtOfWarAbilityHandler = OldArtOfWarAbilityHandler;
